import * as React from "react";
import { Filter, TextInput } from 'react-admin';
import { List, Datagrid, TextField, DateField, useLocaleState } from 'react-admin';
import { TagEdit } from "./tag.edit.component";

const TagListFilter = props => (
    <Filter {...props}>
        <TextInput source="q" alwaysOn resettable />
    </Filter>
);

export const TagList = () => {
    const [locale] = useLocaleState();

    return (
        <List
            filters={<TagListFilter />}
            exporter={false}
        >
            <Datagrid rowClick="edit" expand={<TagEdit/>}>
                <TextField source={`name.${locale}`} />
                <DateField source="createdAt" options={{ day: '2-digit', month: 'short', year: 'numeric' }} />
                <DateField source="updatedAt" options={{ day: '2-digit', month: 'short', year: 'numeric' }} />
            </Datagrid>
        </List>
    );
}